import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMobile } from 'shared/domains/common-ui';
import { SSORestricted } from 'shared/domains/users/components/SSORestricted';
import { useRole } from '../../hooks/useRole';
import { InviteUserModal } from '../InviteUserModal';
export function InviteUserButton(props) {
    const { onInviteCreated } = props;
    const [displayDialog, setDisplayDialog] = useState(false);
    const role = useRole();
    const isMobile = useMobile();
    if (!role.can('invite:user')) {
        return null;
    }
    return (<SSORestricted>
      <Button size={isMobile ? 'small' : 'medium'} onClick={() => setDisplayDialog(true)}>
        <Falcon icon="user-plus"/>
        <Trans comment="Users & teams page header action - invite user">Invite user</Trans>
      </Button>
      {displayDialog && <InviteUserModal onInviteCreated={onInviteCreated} onClose={() => setDisplayDialog(false)}/>}
    </SSORestricted>);
}
